<div class="d-inline">
  <p [class]="titleClass" [class.invalid]="invalid">
    {{ _title }}
    <mdb-icon fas icon="info-circle" *ngIf="tooltip" [mdbTooltip]="tooltip"></mdb-icon>
  </p>
</div>
